import React, { useState } from "react";
import "../css/home.scss";
import { APP_STORE_URL, PLAY_STORE_URL } from "./AppDeepLink";
import Tomko from "./tomko";
import WaveTop from "./WaveTop";

function AccordionItem({ item, isOpen, onToggle }) {
  return (
    <div className={`accordion-item${isOpen ? " open" : ""}`}>
      <button className="accordion-header" onClick={onToggle}>
        <span className="accordion-header-text">{item.contentText}</span>
        <span className="accordion-icon">
          <span className="accordion-arrow" />
        </span>
      </button>
      <div className="accordion-body">
        <p>{item.contentText2}</p>
      </div>
    </div>
  );
}

const Home = ({ data }) => {
  const [openId, setOpenId] = useState(0);
  const [testimonialIndex, setTestimonialIndex] = useState(0);

  const handleToggle = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  const comments = data.comments || [];
  const totalComments = comments.length;

  const handlePrev = () => {
    setTestimonialIndex((prev) =>
      prev === 0 ? Math.max(totalComments - 2, 0) : prev - 1
    );
  };

  const handleNext = () => {
    setTestimonialIndex((prev) =>
      prev >= totalComments - 2 ? 0 : prev + 1
    );
  };

  return (
    <div>
      {/* ===== Hero + Phone Mockups (one continuous blue background) ===== */}
      <section className="home-hero" id="home">
          <div className="home-hero__content">
            <img
              className="home-logo"
              src="images/mascot.png"
              alt="Tomko"
              width={174}
              height={156}
            />
            <h1 className="home-title">
              {data.heroTitle || data.title}
            </h1>
            <p className="home-subtitle">
              {data.heroSubtitle || data.paragraph}
            </p>
            <div className="home-app-buttons">
              <a
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="home-app-btn home-app-btn--android"
                aria-label="Get it on Google Play"
              >
                <img
                  src="images/android.png"
                  alt="Get it on Google Play"
                  width={192}
                  height={64}
                />
              </a>
              <a
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="home-app-btn home-app-btn--ios"
                aria-label="Download on the App Store"
              >
                <img
                  src="images/ios.png"
                  alt="Download on the App Store"
                  width={192}
                  height={64}
                />
              </a>
            </div>
          </div>

          {/* Phone mockups — inside hero so they share the blue background */}
          <div className="phone-mockups">
            <div className="phone-mockups__fan">
              <img src="images/phone_mockup_1.png" alt="" className="phone-mockup phone-mockup--1" />
              <img src="images/phone_mockup_4.png" alt="" className="phone-mockup phone-mockup--2" />
              <img src="images/phone_mockup_5.png" alt="" className="phone-mockup phone-mockup--3" />
              <img src="images/phone_mockup_3.png" alt="" className="phone-mockup phone-mockup--4" />
              <img src="images/phone_mockup_2.png" alt="" className="phone-mockup phone-mockup--5" />
            </div>
          </div>

          <WaveTop fillColor="#F7F7F7" strokeColor="#7FD0EB" />
      </section>

      {/* ===== Section 3: Accordion FAQ ===== */}
      <div className="home-page">
        <div className="home-container">
          <Tomko
            labels={data.tomkoSessions}
            title={data.tomkoExperienceTitle}
            screenshotInstruction={data.tomkoScreenshotInstruction}
          />
          <div className="home-content1">
            <div className="home-content1__inner">
              <div className="accordion-list">
                <h2>{data.subTitle1}</h2>
                {data.content1.map((item, index) => (
                  <AccordionItem
                    key={index}
                    item={item}
                    isOpen={openId === index}
                    onToggle={() => handleToggle(index)}
                  />
                ))}
              </div>
              <div className="accordion-phones">
                <img
                  src="images/dot_pattern.png"
                  alt=""
                  className="accordion-phones__dots accordion-phones__dots--1"
                />
                <img
                  src="images/dot_pattern.png"
                  alt=""
                  className="accordion-phones__dots accordion-phones__dots--2"
                />
                <img
                  src="images/accordion_phone_1.png"
                  alt=""
                  className="accordion-phone accordion-phone--1"
                />
                <img
                  src="images/accordion_phone_2.png"
                  alt=""
                  className="accordion-phone accordion-phone--2"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ===== Section 4: Key Features ===== */}
      <section className="key-features-section">
        <h2 className="key-features-title">{data.subTitle2}</h2>
        <div className="key-features-underline" />
        <div className="key-features-grid">
          {data.content2 &&
            data.content2.map((item, index) => (
              <div className="feature-card" key={index}>
                <div className="feature-card__icon">
                  <img
                    src={item.image}
                    alt={item.contentTitle}
                    className="feature-card__img"
                  />
                </div>
                <h3 className="feature-card__title">{item.contentTitle}</h3>
                <p className="feature-card__desc">{item.contentText}</p>
              </div>
            ))}
        </div>
      </section>

      {/* ===== Section 5: Business Model ===== */}
      <section className="business-model-section">
        <WaveTop fillColor="#E8F6FA" strokeColor="#7FD0EB" />
        <div className="business-model-content">
          <div className="business-model-left">
            <img
              src="images/dot_pattern.png"
              alt=""
              className="business-model-dots business-model-dots--1"
            />
            <img
              src="images/dot_pattern.png"
              alt=""
              className="business-model-dots business-model-dots--2"
            />
            <div className="business-model-image-wrapper">
              <img
                src="images/business_model.png"
                alt={data.subTitle3}
                className="business-model-image"
              />
              <div className="business-model-gradient" />
              <img
                src="images/business_model_logo.png"
                alt=""
                className="business-model-logo"
              />
            </div>
          </div>
          <div className="business-model-right">
            <h2 className="business-model-title">{data.subTitle3}</h2>
            <p className="business-model-desc">{data.subText3}</p>
            <ul className="business-model-list">
              {data.content3 &&
                data.content3.map((item, index) => {
                  const isActive = !!item.image2;
                  return (
                    <li
                      className={`business-model-item${
                        isActive ? "" : " business-model-item--dimmed"
                      }`}
                      key={index}
                    >
                      <img
                        src={
                          isActive
                            ? "images/home/bullet_active.svg"
                            : "images/home/bullet_inactive.svg"
                        }
                        alt=""
                        className="business-model-bullet"
                      />
                      <span>{item.contentText}</span>
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      </section>

      {/* ===== Section 6: Testimonials ===== */}
      {/* <section className="testimonials-section">
        <div className="testimonials-layout">
          <div className="testimonials-left">
            <h2 className="testimonials-title">{data.subTitle4}</h2>
            <div className="testimonials-nav">
              <button
                className="testimonials-arrow"
                onClick={handlePrev}
                aria-label="Previous"
              >
                <img src="images/home/arrowleft.svg" alt="Previous" />
              </button>
              <button
                className="testimonials-arrow"
                onClick={handleNext}
                aria-label="Next"
              >
                <img src="images/home/arrowright.svg" alt="Next" />
              </button>
            </div>
          </div>
          <div className="testimonials-right">
            {comments
              .slice(testimonialIndex, testimonialIndex + 2)
              .concat(
                testimonialIndex + 2 > totalComments
                  ? comments.slice(0, testimonialIndex + 2 - totalComments)
                  : []
              )
              .map((item, index) => (
                <div className="testimonial-item" key={index}>
                  <div className="testimonial-card">
                    <div className="testimonial-stars">
                      {Array.from({ length: item.stars || 5 }).map((_, i) => (
                        <img
                          src="images/home/star.svg"
                          alt="star"
                          className="testimonial-star"
                          key={i}
                        />
                      ))}
                    </div>
                    <p className="testimonial-quote">{item.comment}</p>
                  </div>
                  <div className="testimonial-author">
                    <img
                      src={item.profile || "images/testimonial_avatar.png"}
                      alt={item.username}
                      className="testimonial-avatar"
                    />
                    <div className="testimonial-author-info">
                      <span className="testimonial-name">{item.username}</span>
                      <span className="testimonial-role">{item.profession}</span>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default Home;
